(() => {
  if (!window.customElements || customElements.get('lumidog-variant-picker')) return;
  customElements.define('lumidog-variant-picker', class extends HTMLElement {
    connectedCallback() { this.initialize(); }
    initialize() {
      if (this.ready) return;
      this.select = this.querySelector('[data-variant-select]');
      this.form = this.closest('form');
      this.root = this.closest('[data-product-root]');
      if (!this.select || !this.form || !this.root) return;
      this.groups = [...this.querySelectorAll('[data-option-index]')];
      try {
        this.variants = [...this.select.options].filter(option => option.value).map(option => ({
          id: option.value, values: JSON.parse(option.dataset.options),
          available: option.dataset.available === 'true', price: option.dataset.price,
          image: (option.dataset.image || '').trim(), alt: option.dataset.imageAlt || '',
          title: option.dataset.displayTitle || option.textContent
        }));
      } catch { return; }
      if (!this.variants.length) return;
      this.button = this.form.querySelector('[data-add-button]');
      this.price = this.root.querySelector('[data-product-price]');
      this.image = this.root.querySelector('[data-product-image]');
      this.message = this.querySelector('[data-picker-message]');
      this.select.required = false;
      this.addEventListener('change', event => {
        if (event.target.matches('[data-option-input]')) {
          event.stopPropagation();
          this.choose(true);
        } else if (event.target === this.select && !this.syncing) this.reflect();
      });
      this.form.addEventListener('submit', event => {
        const variant = this.current();
        if (!variant || !variant.available) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.message.textContent = this.pending() ? this.dataset.sizeRequired : this.dataset.selectAvailable;
          const group = this.groups.find(entry => !entry.querySelector('input:checked')) || this.groups[0];
          group?.querySelector('input')?.focus({preventScroll:true});
          group?.scrollIntoView({block:'center',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
        }
      }, true);
      this.form.addEventListener('reset', () => setTimeout(() => this.reflect(), 0));
      this.ready = true;
      this.reflect();
      this.querySelector('.ldvp-options').hidden = false;
      this.classList.add('is-ready');
    }
    current() { return this.variants.find(variant => variant.id === this.select.value); }
    selectedValues() { return this.groups.map(group => group.querySelector('input:checked')?.value || ''); }
    pending() { return this.selectedValues().some(value => !value); }
    reflect() {
      const variant = this.current();
      if (variant) this.groups.forEach((group,index) => group.querySelectorAll('input').forEach(input => { input.checked = input.value === variant.values[index]; }));
      this.render(variant, false);
    }
    selectColor(color) {
      const group = this.querySelector('[data-color-group]');
      const normalize = value => {
        const key=String(value).trim().toLowerCase();
        return ({red:'rouge',blue:'bleu',green:'vert',pink:'rose',yellow:'jaune'})[key] || key;
      };
      const input = [...(group?.querySelectorAll('input') || [])].find(entry => normalize(entry.value) === normalize(color));
      if (!input) return false;
      input.checked = true;
      this.choose(true);
      return true;
    }
    choose(updateImage) {
      const values = this.selectedValues();
      const variant = this.variants.find(entry => entry.values.every((value,index) => value === values[index]));
      this.select.value = variant?.id || '';
      this.select.disabled = false;
      this.render(variant,updateImage);
      if (location.pathname.includes('/products/')) {
        const url = new URL(location.href);
        if (variant) url.searchParams.set('variant',variant.id); else url.searchParams.delete('variant');
        history.replaceState(null,'',url);
      }
      this.syncing = true;
      try { this.select.dispatchEvent(new Event('change',{bubbles:true})); } finally { this.syncing = false; }
    }
    render(variant,updateImage) {
      const values = this.selectedValues();
      const pending = this.pending();
      this.groups.forEach((group,index) => {
        const checked=group.querySelector('input:checked');
        group.querySelector('[data-current-value]').textContent = checked?.dataset.displayValue || this.dataset.sizePending;
        group.querySelectorAll('.ldvp-choice').forEach(choice => {
          const input=choice.querySelector('input');
          const candidates=this.variants.filter(entry => entry.values.every((value,other) => other===index ? value===input.value : !values[other] || value===values[other]));
          const available=candidates.some(entry=>entry.available);
          choice.classList.toggle('is-unavailable',!available);
          choice.querySelector('[data-option-status]').textContent=available?'':(candidates.length?this.dataset.soldOutOption:this.dataset.unavailableOption);
        });
      });
      const candidate=variant || this.variants.find(entry=>entry.values.every((value,index)=>!values[index] || value===values[index]));
      this.button.disabled = !pending && (!variant || !variant.available);
      this.button.textContent = pending ? this.dataset.chooseSize : !variant ? this.dataset.unavailableLabel : variant.available ? this.root.dataset.addLabel : this.root.dataset.soldOutLabel;
      this.price.textContent = candidate?.price || this.dataset.defaultPrice;
      this.root.querySelector('[data-selection-label]').textContent = variant?.title || (pending?this.dataset.sizePending:this.dataset.unavailableLabel);
      this.message.textContent = pending ? '' : !variant ? this.dataset.unavailableMessage : variant.available ? '' : this.dataset.soldOutMessage;
      if (updateImage && candidate?.image && this.image) {
        this.image.removeAttribute('srcset');
        this.image.src=candidate.image;
        this.image.alt=candidate.alt;
      }
      const zoom=this.root.querySelector('[data-image-zoom]');
      if (zoom && this.image) zoom.href=this.image.src;
      this.root.querySelectorAll('[data-gallery-image]').forEach(button=>{
        const same=(url)=>new URL(url,location.origin).pathname;
        button.setAttribute('aria-pressed',String(Boolean(this.image && same(button.dataset.galleryImage)===same(this.image.src))));
      });
      this.root.dispatchEvent(new CustomEvent('lumidog:variant-change'));
    }
  });
})();
